import { IGetCargoByIdUseCase } from "../../../presentation/useCases/read/get_cargo_by_id_use_case";
import { CargoCompleto } from "../../models/cargo_completo";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetCargoByIdUseCase
 */

export class GetCargoByIdUseCase implements IGetCargoByIdUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getCargoById(
    idCargo: number,
  ): Promise<CargoCompleto> {
    return await this.repository.getCargoById(idCargo);
  }
}
